<template>
  <div>
    <br />
    <div class="row justify-content-end">
      <div class="col-auto">
        <button @click="referesh()" class="btn btn-secondary">
          <i class="bi bi-plus-circle"></i>
          Actualiser
        </button>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-xl-3 col-12 my-3">
        <label for=""> Référence </label>
        <div>
          {{ sellerCustomer.reference }}
        </div>
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for=""> Prénom </label>
        <div>
          {{ sellerCustomer.firstName }}
        </div>
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for=""> Nom </label>
        <div>
          {{ sellerCustomer.lastName }}
        </div>
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for=""> Nom Complet </label>
        <div>
          {{ sellerCustomer.fullName }}
        </div>
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for="">Téléphone</label>
        <div>
          {{ sellerCustomer.phone }}
        </div>
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for="">E-mail</label>
        <div>
          {{ sellerCustomer.email }}
        </div>
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for="">Référence Vendeur</label>
        <div>
          {{ sellerCustomer.seller_reference }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters("sellerCustomer", {
      sellerCustomer: "getSellerCustomer",
    }),
  },
  methods: {
    async referesh() {
      await this.$store.dispatch(
        "sellerCustomer/show",
        this.$route.params.reference
      );
    },
  },
  beforeMount() {
    this.$store.dispatch("sellerCustomer/show", this.$route.params.reference);
  },
};
</script>
